export default (theme) => ({
    root: {
        overflow: 'hidden',
        '[class*="FiltersSection__root"] & $header': {
            paddingLeft: 16,
        },
    },
    expanded: {
        marginBottom: 22,
        '& $icon': {
            '& svg': {
                transform: 'rotate(0deg) translateY(0px)',
            },
        },
    },
    header: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 4,
        marginBottom: 22,
        cursor: 'pointer',
    },
    title: {
        color: theme.colors.textLight.secondary,
        fontWeight: 500,
    },
    icon: {
        marginLeft: 'auto',
        marginRight: 4,
        lineHeight: 0,
        alignSelf: 'center',
        cursor: 'pointer',
        '& svg': {
            willChange: 'transform',
            transition: 'transform 0.3s ease-out',
            transform: 'rotate(180deg) translateY(0px)',
        },
        '& svg path': {
            fill: theme.colors.actionMinor[500],
        },
    },
    hint: {
        display: 'inline-flex',
        position: 'relative',
        color: theme.colors.grey[500],
        '&:hover': {
            color: theme.colors.grey[700],
        },
    },
    hintContent: {
        display: 'flex',
        flexFlow: 'column nowrap',
        gap: 12,
    },
    hintContentDescription: {
        display: 'inline',
    },
    new: {
        position: 'absolute',
        top: -6,
        left: 'calc(100% + 2px)',
    },
});
